(function () {
  'use strict';

  function remaining(endMs, nowMs) {
    var diff = Math.floor((endMs - nowMs) / 1000);
    if (!(diff > 0)) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
    return {
      days: Math.floor(diff / 86400),
      hours: Math.floor(diff % 86400 / 3600),
      minutes: Math.floor(diff % 3600 / 60),
      seconds: diff % 60,
      done: false
    };
  }

  function pageCount(scrollWidth, clientWidth) {
    if (!(clientWidth > 0)) return 1;
    return Math.max(1, Math.ceil((scrollWidth - 2) / clientWidth));
  }

  function easeOut(t) {
    t = Math.min(1, Math.max(0, t));
    return 1 - Math.pow(1 - t, 3);
  }

  function tweenValue(from, to, progress) {
    return Math.round(from + (to - from) * easeOut(progress));
  }

  /* Estimated delivery window. Orders after the cutoff hour (or on weekends when skipped) ship next business day. */
  function deliveryRange(now, minDays, maxDays, cutoffHour, skipWeekends) {
    var isOff = function (d) { return skipWeekends && (d.getDay() === 0 || d.getDay() === 6); };
    var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= cutoffHour) ship.setDate(ship.getDate() + 1);
    while (isOff(ship)) ship.setDate(ship.getDate() + 1);
    var add = function (days) {
      var d = new Date(ship);
      var left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        if (!isOff(d)) left--;
      }
      return d;
    };
    return { from: add(minDays), to: add(maxDays) };
  }

  window.jpCore = { remaining: remaining, pageCount: pageCount, easeOut: easeOut, tweenValue: tweenValue, deliveryRange: deliveryRange };

  if (typeof document === 'undefined') return;

  document.documentElement.classList.add('jp-js');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var behavior = function () { return reducedMotion.matches ? 'auto' : 'smooth'; };

  /* Animated number text (money totals). format(cents) -> string */
  window.jpCore.tweenText = function (el, from, to, format, duration) {
    if (!el) return;
    cancelAnimationFrame(el._jpTween || 0);
    if (reducedMotion.matches || from === to || !isFinite(from)) { el.textContent = format(to); return; }
    var start = performance.now();
    var ms = duration || 380;
    (function frame(now) {
      var p = (now - start) / ms;
      el.textContent = format(tweenValue(from, to, p));
      if (p < 1) el._jpTween = requestAnimationFrame(frame);
    })(start);
  };

  /* Reveal on scroll */
  var revealObserver = 'IntersectionObserver' in window && !reducedMotion.matches && !designMode
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-jp-reveal]').forEach(function (el) {
      el.querySelectorAll('[data-jp-reveal-item]').forEach(function (item, i) {
        item.style.setProperty('--jp-i', Math.min(i, 12));
      });
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-revealed');
    });
  }

  document.addEventListener('focusin', function (e) {
    var group = e.target.closest && e.target.closest('[data-jp-reveal]:not(.is-revealed)');
    if (group) group.classList.add('is-revealed');
  });

  /* Marquee pause toggle */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-jp-marquee-toggle]');
    if (!btn) return;
    const paused = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', String(paused));
    btn.setAttribute('aria-label', paused ? 'Spustit animaci' : 'Pozastavit animaci');
    btn.closest('.jp-marquee').classList.toggle('is-paused', paused);
  });

  /* Slider */
  if (!document._jpSliderEditorEventsBound) {
    document._jpSliderEditorEventsBound = true;
    document.addEventListener('shopify:block:select', (e) => {
      var slide = e.target.closest && e.target.closest('.jp-slider__slide');
      var slider = slide && slide.closest('jp-slider[data-jp-keyboard]');
      if (!slider || !slider.track) return;
      slider.editorSelectedSlide = slide;
      slider.editorWasUserPaused = !!slider.userPaused;
      slider.editorSelected = true;
      slider.sync();
      var trackRect = slider.track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      slider.track.scrollTo({
        left: slider.track.scrollLeft + slideRect.left - trackRect.left,
        behavior: behavior()
      });
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      var slide = e.target.closest && e.target.closest('.jp-slider__slide');
      var slider = slide && slide.closest('jp-slider[data-jp-keyboard]');
      if (!slider || slider.editorSelectedSlide !== slide) return;
      slider.editorSelectedSlide = null;
      slider.editorSelected = false;
      if (slider.editorWasUserPaused) slider.userPaused = true;
      slider.editorWasUserPaused = false;
      slider.sync();
    });
  }

  class JpSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.jp-slider__track');
      if (!this.track) return;
      if (!this._bound) this.bind();
      this.resizeObserver.observe(this.track);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    bind() {
      this._bound = true;
      this.prev = this.querySelector('[data-jp-prev]');
      this.next = this.querySelector('[data-jp-next]');
      this.dots = this.querySelector('.jp-slider__dots');
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.resizeObserver = new ResizeObserver(() => { this.buildDots(); this.update(); });
      this.bindDrag();
      this.bindAutoplay();
      if (this.hasAttribute('data-jp-keyboard')) {
        this.track.addEventListener('keydown', (e) => {
          if (e.target !== this.track) return;
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          this.go(e.key === 'ArrowRight' ? 1 : -1);
          this.pauseOnInteraction();
        });
        this.addEventListener('pointerdown', (e) => {
          if (e.target.closest('.jp-slider__toggle')) return;
          this.pauseOnInteraction();
        });
        this.addEventListener('wheel', () => this.pauseOnInteraction(), { passive: true });
      }
    }

    maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    pages() {
      return pageCount(this.track.scrollWidth, this.track.clientWidth);
    }

    page() {
      var max = this.maxScroll();
      if (max <= 0) return 0;
      return Math.round(Math.abs(this.track.scrollLeft) / max * (this.pages() - 1));
    }

    go(dir) {
      var max = this.maxScroll();
      var left = Math.abs(this.track.scrollLeft);
      var loop = this.dataset.loop === 'true';
      if (dir > 0 && left >= max - 2 && loop) return this.track.scrollTo({ left: 0, behavior: behavior() });
      if (dir < 0 && left <= 2 && loop) return this.track.scrollTo({ left: max, behavior: behavior() });
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: behavior() });
    }

    goTo(index) {
      var pages = this.pages();
      this.track.scrollTo({ left: pages > 1 ? this.maxScroll() * index / (pages - 1) : 0, behavior: behavior() });
    }

    buildDots() {
      if (!this.dots) return;
      var pages = this.pages();
      this.dots.hidden = pages < 2;
      if (this.dots.children.length === pages) return;
      this.dots.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'jp-slider__dot';
        dot.setAttribute('aria-label', this.hasAttribute('data-jp-keyboard') ? 'Přejít na stránku ' + (i + 1) + ' z ' + pages : (i + 1) + ' / ' + pages);
        dot.addEventListener('click', () => { this.goTo(i); this.pauseOnInteraction(); });
        this.dots.appendChild(dot);
      }
    }

    update() {
      var max = this.maxScroll();
      var left = Math.abs(this.track.scrollLeft);
      var scrollable = max > 2;
      var loop = this.dataset.loop === 'true';
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prev) this.prev.disabled = !scrollable || (left <= 2 && !loop);
      if (this.next) this.next.disabled = !scrollable || (left >= max - 2 && !loop);
      if (this.toggle && this.hasAttribute('data-jp-keyboard')) this.toggle.hidden = !scrollable;
      if (this.dots) {
        var current = this.page();
        Array.prototype.forEach.call(this.dots.children, function (dot, i) {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }
    }

    bindDrag() {
      var startX = 0, startLeft = 0, pointerId = null, moved = false;
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        pointerId = e.pointerId; moved = false;
        startX = e.clientX; startLeft = this.track.scrollLeft;
      });
      this.track.addEventListener('pointermove', (e) => {
        if (e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          this.track.setPointerCapture(pointerId);
          this.classList.add('is-dragging');
        }
        if (moved) this.track.scrollLeft = startLeft - dx;
      });
      var end = (e) => {
        if (e.pointerId !== pointerId) return;
        pointerId = null;
        this.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);
      this.track.addEventListener('click', (e) => {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    bindAutoplay() {
      var seconds = parseFloat(this.dataset.autoplay || '0');
      if (!(seconds > 0) || reducedMotion.matches || (designMode && !this.hasAttribute('data-jp-keyboard'))) return;
      this.delay = seconds * 1000;
      if (!this.hasAttribute('data-jp-keyboard')) this.dataset.loop = 'true';
      this.hovered = false;
      this.focused = false;
      this.userPaused = false;

      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'jp-slider__toggle';
      this.toggle.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path class="jp-i-pause" d="M5 3v10M11 3v10"/><path class="jp-i-play" d="M5 3l8 5-8 5z"/></svg>';
      this.toggle.addEventListener('click', () => {
        if (this.userPaused && this.dataset.loop !== 'true' && this.maxScroll() > 2 && Math.abs(this.track.scrollLeft) >= this.maxScroll() - 2) {
          this.goTo(0);
        }
        this.userPaused = !this.userPaused;
        this.sync();
      });
      this.appendChild(this.toggle);

      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); }
      });
      this.addEventListener('touchstart', () => { this.userPaused = true; this.sync(); }, { passive: true });
      this.sync();
    }

    pauseOnInteraction() {
      if (!this.hasAttribute('data-jp-keyboard') || !this.toggle) return;
      this.userPaused = true;
      this.sync();
    }

    sync() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.userPaused ? 'Spustit' : 'Pozastavit');
      this.toggle.classList.toggle('is-paused', this.userPaused);
      if (this.userPaused || this.hovered || this.focused || this.editorSelected) this.stop();
      else this.start();
    }

    start() {
      this.stop();
      if (!this.delay || this.userPaused || this.hovered || this.focused || this.editorSelected || !this.isConnected || (this.hasAttribute('data-jp-keyboard') && reducedMotion.matches)) return;
      this.timer = setInterval(() => {
        if (this.hasAttribute('data-jp-keyboard') && reducedMotion.matches) { this.stop(); return; }
        if (this.hasAttribute('data-jp-keyboard') && this.pages() < 2) return;
        if (this.hasAttribute('data-jp-keyboard') && this.dataset.loop !== 'true' && this.track.scrollLeft >= this.maxScroll() - 2) {
          this.userPaused = true;
          this.sync();
          return;
        }
        this.go(1);
      }, this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /* Tabs */
  class JpTabs extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (e) => {
          var next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 }[e.key];
          if (next === undefined) return;
          e.preventDefault();
          this.select(this.tabs[(next + this.tabs.length) % this.tabs.length], true);
        });
      });
      var current = this.querySelector('[role="tab"][aria-selected="true"]');
      if (current) {
        this.moveIndicator(current);
        new ResizeObserver(() => {
          var active = this.querySelector('[role="tab"][aria-selected="true"]');
          if (active) this.moveIndicator(active);
        }).observe(current.parentElement);
      }
      this.addEventListener('shopify:block:select', (e) => {
        var tab = this.querySelector('#JpTab-' + e.detail.blockId);
        if (tab) this.select(tab);
      });
    }

    moveIndicator(tab) {
      var list = tab.parentElement;
      list.classList.add('has-indicator');
      list.style.setProperty('--jp-ind-x', tab.offsetLeft + 'px');
      list.style.setProperty('--jp-ind-w', tab.offsetWidth + 'px');
    }

    select(tab, focus) {
      this.moveIndicator(tab);
      this.tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
  }

  /* Promo tile moved into the collection grid */
  var WIDTH_CLASS = /^(small--|medium-up--|large-up--)/;
  var WIDER = { 'one-quarter': 'one-half', 'one-third': 'two-thirds', 'one-fifth': 'two-fifths', 'one-sixth': 'one-third', 'one-half': 'one-whole' };

  class JpPromoTile extends HTMLElement {
    connectedCallback() {
      if (this._placing) return;
      this.place();
      if (!this._listening) {
        this._listening = true;
        this.onReload = () => this.place();
        document.addEventListener('collection:reloaded', this.onReload);
      }
    }

    place() {
      var grid = document.querySelector('#CollectionAjaxContent .grid--uniform') || document.querySelector('#CollectionAjaxContent .grid');
      if (!grid) return;
      var items = grid.querySelectorAll(':scope > .grid__item:not(jp-promo-tile)');
      var ref = items[Math.max(1, parseInt(this.dataset.position, 10) || 1) - 1];
      Array.prototype.slice.call(this.classList).forEach((c) => { if (WIDTH_CLASS.test(c)) this.classList.remove(c); });
      var span2 = this.dataset.span === '2';
      if (items[0]) {
        items[0].className.split(' ').filter(function (c) { return WIDTH_CLASS.test(c); }).forEach((c) => {
          if (span2) c = c.replace(/(one-quarter|one-third|one-fifth|one-sixth|one-half)$/, function (m) { return WIDER[m]; });
          this.classList.add(c);
        });
      }
      this.classList.add('grid__item', 'is-placed');
      this._placing = true;
      if (ref) grid.insertBefore(this, ref);
      else grid.appendChild(this);
      this._placing = false;
      if (items[0]) this.style.minHeight = items[0].offsetHeight + 'px';
    }

    remove() {
      if (this.onReload) document.removeEventListener('collection:reloaded', this.onReload);
      HTMLElement.prototype.remove.call(this);
    }
  }

  document.addEventListener('shopify:section:unload', function (e) {
    document.querySelectorAll('jp-promo-tile[data-section-id="' + e.detail.sectionId + '"]').forEach(function (tile) { tile.remove(); });
  });

  /* Countdown to a fixed date */
  class JpCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.units = {};
      this.querySelectorAll('[data-unit]').forEach((el) => { this.units[el.dataset.unit] = el; });
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var r = remaining(this.end, Date.now());
      Object.keys(this.units).forEach((unit) => {
        var el = this.units[unit];
        var text = String(r[unit]).padStart(2, '0');
        if (el.textContent !== text) {
          el.textContent = text;
          if (!reducedMotion.matches && el.classList.contains('jp-cdb__num')) {
            el.classList.remove('is-tick');
            void el.offsetWidth;
            el.classList.add('is-tick');
          }
        }
      });
      if (!r.done) return;
      clearInterval(this.timer);
      this.classList.add('is-expired');
      var unitsBox = this.querySelector('[data-jp-units]');
      var expiredMsg = this.querySelector('[data-jp-expired]');
      if (expiredMsg) { expiredMsg.hidden = false; if (unitsBox) unitsBox.hidden = true; }
      if (this.dataset.hideExpired === 'true') {
        var wrap = this.closest('[data-jp-countdown-wrap]');
        if (wrap) wrap.hidden = true;
      }
    }
  }

  /* Background video: respect reduced motion, pause button */
  function initVideos(root) {
    root.querySelectorAll('[data-jp-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-jp-video-toggle]');
      if (!video || wrap._jpBound) return;
      wrap._jpBound = true;
      function set(paused) {
        if (paused) video.pause(); else video.play().catch(function () {});
        if (btn) {
          btn.classList.toggle('is-paused', paused);
          btn.setAttribute('aria-label', paused ? 'Spustit video' : 'Pozastavit video');
        }
      }
      if (wrap.closest('jp-hero')) {
        // Hero playback is managed by its active slide.
        btn.classList.toggle('is-paused', video.paused);
        btn.setAttribute('aria-label', video.paused ? 'Spustit video' : 'Pozastavit video');
      } else set(reducedMotion.matches);
      if (btn) btn.addEventListener('click', function () { set(!video.paused); });
    });
  }

  /* Shared rotator: timed slides with pause on hover/focus, pause button, prev/next */
  class JpRotator extends HTMLElement {
    setupRotator(slideSelector, delaySeconds) {
      this.slides = Array.prototype.slice.call(this.querySelectorAll(slideSelector));
      this.index = 0;
      this.delay = delaySeconds * 1000;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } });
      this.sync();
    }

    canPlay() {
      return this.delay > 0 && this.slides.length > 1 && !reducedMotion.matches && !designMode &&
        !this.userPaused && !this.hovered && !this.focused && this.isConnected;
    }

    sync() {
      clearTimeout(this.timer);
      var playing = this.canPlay();
      this.classList.toggle('is-playing', playing);
      if (this.pauseBtn) {
        this.pauseBtn.classList.toggle('is-paused', this.userPaused);
        this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Spustit' : 'Pozastavit');
      }
      if (playing) this.timer = setTimeout(() => { this.goTo(this.index + 1, 1); this.sync(); }, this.delay);
    }

    goTo(i, dir) {
      var n = this.slides.length;
      if (!n) return;
      var next = (i + n) % n;
      if (next === this.index) return;
      var prev = this.slides[this.index];
      var cur = this.slides[next];
      prev.classList.remove('is-active', 'is-from-left');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      prev.setAttribute('inert', '');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 900);
      cur.classList.remove('is-leaving');
      cur.classList.toggle('is-from-left', dir < 0);
      void cur.offsetWidth;
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.removeAttribute('inert');
      this.index = next;
      this.dataset.index = next;
      if (this.onChange) this.onChange(next);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  class JpAnnounce extends JpRotator {
    connectedCallback() {
      if (this._bound) { this.sync(); return; }
      this._bound = true;
      try {
        if (localStorage.getItem(this.dataset.key) === '1' && !designMode) { this.hidden = true; return; }
      } catch (e) {}
      this.pauseBtn = this.querySelector('[data-jp-ann-pause]');
      this.onChange = (i) => {
        this.slides.forEach(function (s, k) {
          s.querySelectorAll('a').forEach(function (a) { a.tabIndex = k === i ? 0 : -1; });
        });
      };
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-jp-ann-next]')) { this.goTo(this.index + 1, 1); this.sync(); }
        else if (e.target.closest('[data-jp-ann-prev]')) { this.goTo(this.index - 1, -1); this.sync(); }
        else if (e.target.closest('[data-jp-ann-pause]')) { this.userPaused = !this.userPaused; this.sync(); }
        else if (e.target.closest('[data-jp-dismiss]')) {
          try { localStorage.setItem(this.dataset.key, '1'); } catch (err) {}
          this.hidden = true;
          clearTimeout(this.timer);
        }
      });
      this.setupRotator('[data-jp-ann-msg]', parseFloat(this.dataset.interval) || 5);
    }
  }

  class JpHero extends JpRotator {
    connectedCallback() {
      if (this._bound) { this.sync(); return; }
      this._bound = true;
      this.pauseBtn = this.querySelector('[data-jp-hero-pause]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-jp-hero-dot]'));
      this.syncVideos = () => {
        this.slides.forEach((slide) => {
          var wrap = slide.querySelector('[data-jp-video]');
          var video = wrap && wrap.querySelector('video');
          if (!video) return;
          var paused = !slide.classList.contains('is-active') || reducedMotion.matches;
          if (paused) video.pause();
          var btn = wrap.querySelector('[data-jp-video-toggle]');
          if (btn) {
            btn.classList.toggle('is-paused', paused);
            btn.setAttribute('aria-label', paused ? 'Spustit video' : 'Pozastavit video');
          }
          if (!paused) {
            video.play().then(function () {
              if (btn) {
                btn.classList.remove('is-paused');
                btn.setAttribute('aria-label', 'Pozastavit video');
              }
            }).catch(function () {
              if (btn) {
                btn.classList.add('is-paused');
                btn.setAttribute('aria-label', 'Spustit video');
              }
            });
          }
        });
      };
      this.onChange = (i) => {
        this.dots.forEach(function (d, k) {
          if (k === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        this.syncVideos();
      };
      this.addEventListener('click', (e) => {
        var dot = e.target.closest('[data-jp-hero-dot]');
        if (e.target.closest('[data-jp-hero-next]')) this.goTo(this.index + 1, 1);
        else if (e.target.closest('[data-jp-hero-prev]')) this.goTo(this.index - 1, -1);
        else if (dot) {
          var to = parseInt(dot.dataset.jpHeroDot, 10);
          this.goTo(to, to > this.index ? 1 : -1);
        }
        else if (e.target.closest('[data-jp-hero-pause]')) this.userPaused = !this.userPaused;
        else return;
        this.sync();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.goTo(this.index + 1, 1); this.sync(); }
        if (e.key === 'ArrowLeft') { this.goTo(this.index - 1, -1); this.sync(); }
      });
      var startX = null;
      this.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') startX = e.clientX; });
      this.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 50) { this.goTo(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); this.sync(); }
      });
      this.addEventListener('shopify:block:select', (e) => {
        var i = this.slides.findIndex(function (s) { return s === e.target || s.contains(e.target); });
        if (i > -1) { this.userPaused = true; this.goTo(i, 1); this.sync(); }
      });
      this.setupRotator('[data-jp-hero-slide]', parseFloat(this.dataset.autoplay) || 0);
      this.syncVideos();
    }
  }

  if (window.customElements) {
    if (!customElements.get('jp-announce')) customElements.define('jp-announce', JpAnnounce);
    if (!customElements.get('jp-hero')) customElements.define('jp-hero', JpHero);
    if (!customElements.get('jp-slider')) customElements.define('jp-slider', JpSlider);
    if (!customElements.get('jp-tabs')) customElements.define('jp-tabs', JpTabs);
    if (!customElements.get('jp-promo-tile')) customElements.define('jp-promo-tile', JpPromoTile);
    if (!customElements.get('jp-countdown')) customElements.define('jp-countdown', JpCountdown);
  }

  /* Product delivery estimate */
  function initDelivery(root) {
    root.querySelectorAll('[data-jp-delivery]').forEach(function (el) {
      var d = el.dataset;
      var r = deliveryRange(new Date(), parseInt(d.min, 10) || 0, parseInt(d.max, 10) || 0, parseInt(d.cutoff, 10), d.skip === 'true');
      var lang = document.documentElement.lang || 'cs';
      var fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'numeric' });
      var out = el.querySelector('[data-jp-delivery-range]');
      out.textContent = r.from.getTime() === r.to.getTime() ? fmt.format(r.from) : fmt.format(r.from) + ' – ' + fmt.format(r.to);
    });
  }

  /* Real stock level (tracked inventory only) */
  function renderStock(el, variantId) {
    var data = el._jpStock;
    if (!data) {
      try { data = el._jpStock = JSON.parse(el.querySelector('[data-jp-stock-data]').textContent); } catch (e) { data = el._jpStock = {}; }
    }
    var qty = data[String(variantId)];
    var threshold = parseInt(el.dataset.threshold, 10) || 10;
    var show = typeof qty === 'number' && qty > 0 && qty <= threshold;
    el.hidden = !show;
    if (!show) return;
    el.querySelector('[data-jp-stock-text]').textContent = (el.dataset.text || '').replace('[count]', qty);
    var fill = el.querySelector('[data-jp-stock-fill]');
    if (fill) fill.style.width = Math.max(6, Math.round(qty / threshold * 100)) + '%';
  }

  function initStock(root) {
    root.querySelectorAll('[data-jp-stock]').forEach(function (el) {
      var cur = el.querySelector('[data-jp-stock-current]');
      renderStock(el, cur ? cur.getAttribute('data-jp-stock-current') : '');
    });
  }

  document.addEventListener('variantChange', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var scope = (e.target && e.target.querySelectorAll) ? e.target : document;
    scope.querySelectorAll('[data-jp-stock]').forEach(function (el) { renderStock(el, v.id); });
  }, true);

  function init(root) {
    root = root || document;
    initReveal(root);
    initVideos(root);
    initDelivery(root);
    initStock(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.jpCore.init = init;
})();
